import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Alert from 'react-s-alert';
import 'react-s-alert/dist/s-alert-default.css';
import 'react-s-alert/dist/s-alert-css-effects/slide.css';

// // Stripe
// import { Elements } from '@stripe/react-stripe-js';
// import { loadStripe } from '@stripe/stripe-js';

// import { STRIPE_KEY } from '../utils/Settings'

// contents
import AppStart from './pre_login/AppStart'
import CreateAccount from './pre_login/CreateAccount'
import Dashboard from './after_login/Dashboard'
import AccountBase from './after_login/account/AccountBase'
import LoginView from './pre_login/LoginView'
import TermsOfUse from './pre_login/TermsOfUse'
import PrivacyPolicy from './pre_login/PrivacyPolicy'
import EmailValidate from './pre_login/EmailValidate'
import WaitVerification from './pre_login/WaitVerification'
import PaymentTop from './after_login/payment/PaymentTop'
import PaymentAdd from './after_login/payment/PaymentAdd'
import PaymentHistoryList from './after_login/payment/PaymentHistoryList'
import ApiTokenManager from './after_login/api/ApiTokenManager'
import ApiManagerTop from './after_login/api/ApiManagerTop'
import ApiUsageSummary from './after_login/api/ApiUsageSummary'
import ApiManagerModels from './after_login/api/ApiManagerModels'
import ApiDictManager from './after_login/api/ApiDictManager'
import AudioEditorTop from './after_login/audio_editor/AudioEditorTop'
import ApiMonitoringWordManager from './after_login/api/ApiMonitoringWordManager'
import ApiAspIdManager from './after_login/api/ApiAspIdManager'


// document
import DocsTop from './after_login/docs/DocsTop'
import DocsReference from './after_login/docs/DocsReference'
import DocsMiniDict from './after_login/docs/DocsMiniDict'

// // project Narancia
// import NaranciaTop from './after_login/narancia/NaranciaTop'
// import NaranciaUpload from './after_login/narancia/NaranciaUpload'
// import NaranciaAnnotation from './after_login/narancia/NaranciaAnnotationSplit'

// import NaranciaView from './after_login/narancia/NaranciaView'
// import NaranciaTest from './after_login/narancia/NaranciaTest'
// import NaranciaOpenTool from './after_login/narancia/NaranciaOpenTool'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faTrash,
  faCheck,
  faRedo,
  faPlay,
  faArrowRight,
  faArrowLeft,
  faArrowDown,
  faSave,
  faStepBackward,
  faPause,
  faBlog,
  faSkullCrossbones,
  faWrench,
  faPoo,
  faEdit,
  faTimes,
  faFlag,
  faThumbsUp,
  faThumbsDown,
  faDizzy,
  faDownload,
  faMapMarker,
  faPlayCircle,
  faPauseCircle,
  faHeadphonesAlt,
  faList,
  faTasks,
  faCheckDouble,
  faMicrophone,
  faStop,
  faFire,
  faBaseballBall,
  faRobot,
  faSurprise,
  faSmileBeam,
  faSmile,
  faMeh,
  faFrown,
  faPlusSquare,
  faMagic,
  faUpload,
  faFileDownload,
  faCheckCircle,
  faPlusCircle,
  faMehRollingEyes,
  faBomb,
  faFlask,
  faCircleNotch,
  faFileArchive,
  faRocket,
  faMinusCircle,
  faArchive,
  faMoneyCheck,
  faEye,
  faArrowCircleDown,
  faSearch,
  faLongArrowAltUp,
  faLemon,
  faSpellCheck,
  faStar,
  faHandPointer,
  faArrowsAltV,
  faIndent,
  faToggleOff,
  faToggleOn,
  faExpand,
  faCompress,
  faEyeSlash,
  faShareFromSquare,
} from '@fortawesome/free-solid-svg-icons'

library.add(faPlusCircle, faCheckCircle, faFileDownload, faArrowDown, faTrash, faCheck,
  faRedo, faPlay, faArrowRight, faSave, faStepBackward, faPause, faBlog, faSkullCrossbones,
  faWrench, faPoo, faEdit, faTimes, faFlag, faThumbsUp, faDizzy, faDownload, faMapMarker,
  faPlayCircle, faPauseCircle, faHeadphonesAlt, faList, faTasks, faArrowLeft, faCheckDouble, faMicrophone,
  faStop, faFire, faThumbsDown, faBaseballBall, faRobot, faSurprise, faSmileBeam, faMeh,
  faFrown, faPlusSquare, faMagic, faUpload, faMehRollingEyes, faBomb, faFlask, faCircleNotch, faFileArchive,
  faRocket, faMinusCircle, faArchive, faMoneyCheck, faEye, faArrowCircleDown,
  faSearch, faLongArrowAltUp, faLemon, faSpellCheck, faStar, faSmile, faHandPointer,
faArrowsAltV, faIndent, faToggleOff, faToggleOn, faExpand, faCompress, faEyeSlash,
faShareFromSquare)

// Stripe
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
// const stripePromise = loadStripe(STRIPE_KEY);

// App
const App = (props) => {

  return (
    // <Elements stripe={stripePromise}>
      <div className="App">

        <Routes>

          <Route path="/" element={<AppStart />}></Route>

          <Route path="/create_account" element={<CreateAccount />}></Route>

          <Route path="/login" element={<LoginView />}></Route>

          <Route path="/dashboard" element={<Dashboard />}></Route>

          <Route path="/account" element={<AccountBase />}></Route>

          <Route path="/api_token_manager" element={<ApiTokenManager />}></Route>

          <Route path="/api_manager_top" element={<ApiManagerTop />}></Route>

          <Route path="/terms_of_use" element={<TermsOfUse />}></Route>

          <Route path="/privacy_policy" element={<PrivacyPolicy />}></Route>

          <Route path="/api_usage" element={<ApiUsageSummary />}></Route>

          <Route path="/api_models" element={<ApiManagerModels />}></Route>

          <Route path="/api_dict_manager" element={<ApiDictManager />}></Route>

          <Route path="/api_monitoring_words" element={<ApiMonitoringWordManager />}></Route>

          <Route path="/audio_editor" element={<AudioEditorTop />}></Route>

          <Route path="/email_validate" element={<EmailValidate />}></Route>

          <Route path="/pre_registration" element={<WaitVerification />}></Route>

          <Route path="/payment_top" element={<PaymentTop />}></Route>

          <Route path="/payment_add" element={<PaymentAdd />}></Route>

          <Route path="/payment_history" element={<PaymentHistoryList />}></Route>

          <Route path="/docs_top" element={<DocsTop />}></Route>

          <Route path="/docs_reference" element={<DocsReference />}></Route>

          <Route path="/docs_mini_dict" element={<DocsMiniDict />}></Route>

          {/* <Route path="/narancia_top" element={<NaranciaTop />}></Route> */}

          {/* <Route path="/narancia_upload" element={<NaranciaUpload />}></Route> */}

          {/* <Route path="/narancia_annotation" element={<NaranciaAnnotation />}></Route> */}

          {/* <Route path="/narancia_view" element={<NaranciaView />}></Route> */}

          {/* <Route path="/narancia_test" element={<NaranciaTest />}></Route> */}

          {/* <Route path="/narancia_open_tool" element={<NaranciaOpenTool />}></Route> */}

          <Route path="/api_aspid_top" element={<ApiAspIdManager />}></Route>
          

        </Routes>

        <Alert stack={{limit: 3}} />

      </div>
    // </Elements>
  )
}

export default App
